(function () {
    'use strict';

    angular
        .module('app')
        .controller('signalrStatus', signalrStatus);

    signalrStatus.$inject = ['$scope', 'hubFactory', '$rootScope', '$document'];

    function signalrStatus($scope, hubFactory, $rootScope, $document) {
        /* jshint validthis:true */
        var vm = this;
        vm.title = 'signalrStatus';
        vm.connected = false;
        $scope.show = false;

        $scope.$watch(function () {
            return $rootScope.loginHub.connected;
        }, function (val) {
            vm.connected = val;
            console.log("signal r changed status to:", val);
        });

        $scope.$watch(function () {
            return $rootScope.loginHub.reconnecting;
        }, function (val) {
            vm.reconnecting = val;
            });

        vm.close = function () {
            $scope.show = false;

        }

        
        activate();

        function activate() { }
    }
})();
